/* import __COLOCATED_TEMPLATE__ from './address-input-field-street2-old.hbs.js'; */
var _dec, _class;
import { tagName } from '@ember-decorators/component';
import AddressInputFieldStreet2 from './address-input-field-street2';
let AddressInputFieldStreet2Old = (_dec = tagName(''), _dec(_class = class AddressInputFieldStreet2Old extends AddressInputFieldStreet2 {}) || _class);
export { AddressInputFieldStreet2Old as default };